<template>
  <v-container class="mt-5">
    <h2 class="primary--text">Tutorial de utilização AMI</h2>
    <p>Bem vindo a plataforma Limer. Aqui sua saúde ocupacional está organizada e digitalizada.</p>

    <h3 class="pt-5">Passo 1</h3>
    <p>
      Para acessar sua guia digitalizada e preencher a ficha clínica acesse
      <a href="https://ami.limer.med.br">ami.limer.med.br</a>.
    </p>

    <h3>Passo 2</h3>
    <p>
      Insira seu CPF, para ter acesso ao seu aplicativo de saúde a empresa já deve ter adicionado seu CPF a base de
      usuários, caso tenha problemas entre em contato com nosso suporte.
    </p>

    <h3>Passo 3</h3>
    <p>Insira sua senha, caso não tenha a plataforma solicitará um breve cadastro.</p>

    <h3>Passo 4</h3>
    <p>Você será redirecionado para os seus agendamentos. Verifique as informações no card do seu agendamento.</p>

    <h3>Passo 5</h3>
    <p>
      Antes de ir a consulta ou acessar a sala virtual lembre-se de preencher a ficha clínica digital no card do seu
      agendamento.
    </p>

    <h3>Passo 6</h3>
    <p>Após o atendimento seu ASO será disponibilizado pelo médico na plataforma em até 24 horas.</p>
    <p>
      Para acessar o resultado basta voltar em <a href="https://ami.limer.med.br">ami.limer.med.br</a> e clicar em
      <strong style="text-decoration: underline">exames finalizados.</strong>
    </p>
  </v-container>
</template>

<script>
export default {}
</script>

<style scoped>
h3,
p {
  color: #7f7f7f;
}

h3 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
}

p:last-child {
  margin-bottom: 5em;
}
</style>
